module.exports = __webpack_public_path__ + "static/16.4_Early_Middle_Ages-5636646e665311cda3c7239ad34df9cf.pdf";